const mailTemplates = {
	CONSUMPTION: {
		display: 'Zählerstände \u007C Verbrauchsdaten',
		description:
			'Empfänger: Kunde - Informiert berechtigte Benutzer darüber dass mit der letzten Datenaktualisierung neue Verbrauchsdaten hochgeladen wurden',
		preview: '',
	},
	DAMAGE_REPORT: {
		display: 'Schadensmeldung \u007C Neu',
		preview: 'damagereport',
		description:
			'Empfänger: Kunde/Hausverwalter - Beinhaltet die Informationen zur erstellten Schadensmeldung',
		info: 'Bitte beachten Sie, dass es sich bei den Feldern "Standort des Schadens" und "Beschreibung des Schadens" um hinterlegte Beispieltexte  handelt',
	},
	DOCUMENT_USER_DAILY: {
		display: 'Dokumente \u007C Neu',
		preview: 'documentusernotifier',
		description:
			'Empfänger: Kunde - Wird versendet wenn neue Dokumente vorliegen',
		info: 'Bitte beachten Sie, dass es sich um zufällige Dokumente für den Benutzer handelt',
	},
	HANDOVER_INVITATION: {
		display: 'Wohnungsübergabe \u007C Terminvorschlag',
		description:
			'Empfänger: Kunde - Wird an die verknüpften Benutzer verschickt, sobald eine neue Wohnungsübergabe mit entsprechender Terminierung erstellt wurde',
		preview: '',
	},
	LOST_PASSWORD: {
		display: 'Account \u007C Passwort vergessen',
		description:
			'Empfänger: Kunde / Hausverwaltung - Wird versendet wenn die "Passwort vergessen" Funktion verwendet wird',
		preview: 'lostpassword',
	},
	MESSAGE: {
		display: 'Nachricht \u007C Neu',
		description:
			'Empfänger: Kunde / Hausverwaltung - Wird versendet wenn eine neue Nachricht erstellt wurde',
		info: 'Bitte beachten Sie, dass es sich bei dem Feld "Mitteilung" um einen hinterlegten Beispieltext handelt',
		preview: 'message',
	},
	MESSAGE_DONE: {
		display: 'Nachricht \u007C Bearbeitet',
		description:
			'Empfänger: Kunde - Informiert den Kunden darüber dass seine Nachricht bearbeitet wurde',
		preview: '',
	},
	/*METER_LEVEL: { display: 'Zählerstande \u007C Neu', preview: '' },*/
	METER_LEVEL_DAILY: {
		display: 'Zählerstände \u007C Nicht freigegeben',
		description:
			'Empfänger: Hausverwaltung - Wird versendet wenn noch freizugebene Zählerstände vorliegen',
		preview: 'meterleveldaily',
	},
	METER_LEVEL_REJECTED: {
		display: 'Zählerstande \u007C Abgelehnt',
		description:
			'Empfänger: Hausverwaltung - Wird versendet wenn die Übernahme eines Zählerstands abgelehnt wurde',
		preview: 'meterlevelreject',
	},
	NOTES: {
		display: 'Notiz \u007C Neu',
		description:
			'Empfänger: Kunde - Wird versendet wenn eine neue Notiz mit Benachrichtigung erstellt wird',
		preview: 'note',
	},
	PRIVACY_TOS_REJECTED: {
		display: 'Account \u007C Nutzungsbedingungen abgelehnt',
		description:
			'Empfänger: Hausverwaltung - Informiert darüber dass ein Kunde den Nutzungs- oder Datenschutzbedingungen widersprochen hat',
		preview: 'privacytosreject',
	},
	SYNC_PROCESSED: {
		display: 'Datenaktualisierung',
		description:
			'Empfänger: Hausverwaltung - Beinhaltet eine Übersicht über die aktualisierten Daten, nachdem eine Datenaktualisierung erfolgreich abgeschlossen wurde',
		preview: '',
	},
	PERSON_DATA_CHANGE_REQUESTED: {
		display: 'Datenänderungsanfrage \u007C Neu',
		description:
			'Empfänger: Kunde - Wird versendet wenn eine neue Datenänderungsanfrage erstellt wurde',
		preview: 'personupdaterequest',
		name: 'requested',
	},
	PERSON_DATA_CHANGE_ACCEPTED: {
		display: 'Datenänderungsanfrage \u007C Akzeptiert',
		description:
			'Empfänger: Kunde - Wird versendet wenn eine offene Datenänderungsanfrage akzeptiert wird',
		preview: 'personupdaterequest',
		name: 'accepted',
	},
	PERSON_DATA_CHANGE_DECLINED: {
		display: 'Datenänderungsanfrage \u007C Abgelehnt',
		description:
			'Empfänger: Kunde - Wird versendet wenn eine offene Datenänderungsanfrage abgelehnt wird',
		preview: 'personupdaterequest',
		name: 'declined',
	},
	REVIEW_DOCUMENT_STARTED: {
		display: 'Belegprüfung \u007C Neu',
		description:
			'Empfänger: Kunde/Prüfer - Wird versendet wenn eine Belegprüfung aktiv geschaltet wurde',
		preview: '',
	},
	REVIEW_DOCUMENT_REMINDER: {
		display: 'Belegprüfung \u007C Erinnerung',
		description:
			'Empfänger: Kunde/Prüfer - Wird versendet wenn die Erinnerungsfunktion für eine Belegprüfung aktiviert ist',
		preview: '',
	},
	REVIEW_DOCUMENT_EXPIRED: {
		display: 'Belegprüfung \u007C Abgelaufen',
		description:
			'Empfänger: Hausverwaltung - Wird versendet wenn die Frist einer Belegprüfung abgelaufen ist',
		preview: '',
	},
	REVIEW_DOCUMENT_ACCEPTED: {
		display: 'Belegprüfung \u007C Akzeptiert',
		description:
			'Empfänger: Hausverwaltung - Wird versendet wenn eine Belegprüfung akzeptiert wurde',
		preview: '',
	},
	REVIEW_DOCUMENT_DECLINED: {
		display: 'Belegprüfung \u007C Abgelehnt',
		description:
			'Empfänger: Kunde/Prüfer - Wird versendet wenn eine Belegprüfung aktiv geschaltet wurde',
		preview: '',
	},
	REVIEW_DOCUMENT_FINISHED: {
		display: 'Belegprüfung \u007C Abgeschlossen',
		description:
			'Empfänger: Kunde/Prüfer - Wird versendet wenn eine Belegprüfung abgeschlossen wurde',
		preview: '',
	},
	REVIEW_DOCUMENT_COMMENTED: {
		display: 'Belegprüfung \u007C Kommentiert',
		description:
			'Empfänger: Kunde/Prüfer - Wird versendet wenn eine Belegprüfung kommentiert wurde',
		preview: '',
	},
	REPORT_STARTED: {
		display: 'Meldung \u007C Neu',
		description:
			'Empfänger: Kunde - Informiert den Empfänger darüber das die Meldung bei der Hausverwaltung eingegangen ist',
		preview: '',
	},
	REPORT_STATUS_CHANGED: {
		display: 'Meldung \u007C Aktualisiert ',
		description:
			'Empfänger: Kunde - Informiert den Empfänger über die Änderungen des Bearbeitungsstatus',
		preview: '',
	},
	REPORT_CRAFTSMAN_TASK_STARTED: {
		display: 'Meldung \u007C Handwerker wurde beauftragt',
		description:
			'Empfänger: Kunde - Informiert den Empfänger darüber das ein Handwerker beauftragt wurde',
		preview: '',
	},
	REPORT_STATUS_FINISHED: {
		display: 'Meldung \u007C Abgeschlossen ',
		description:
			'Empfänger: Kunde - Informiert den Empfänger darüber das die Meldung geschlossen wurde',
		preview: '',
	},
	TICKET_HISTORY: {
		display: 'Ticket \u007C Aktualisierungen',
		description:
			'Empfänger: Kunde - Informiert den Empfänger über die vorgenommenen Änderungen an einem Ticket oder dessen zugehöriger Daten',
		preview: '',
	},
	WELCOME: {
		display: 'Account \u007C Zugangsdaten',
		preview: 'welcome',
		description:
			'Empfänger: Kunde - Wenn der automatische Versand von Begrüßungsemails aktiviert ist oder eine Begrüßungsemail manuell versendet wird',
	},
}

export default mailTemplates
